import React from 'react'
import PropTypes from 'prop-types'
import moment from "moment"

function UsersStaticsDetailTableItem(props) {
    const {item} = props
    const {partner, sewingPartner} = item
    const partnerStr = [partner ? partner : '-', sewingPartner ? sewingPartner : '-'].join('/')
    return (
        <tr className="UsersStaticsDetailTableItem">
            <td>{item.user}</td>
            <td>{item.action || ''}</td>
            <td>{moment(item.created).format('DD/MM/YYYY HH:mm')}</td>
            <td>{item.barcode || ''}</td>
            <td>{item.sku || ''}</td>
            <td>{item.size || ''}</td>
            <td>{item.batch || ''}</td>
            <td>{item.box || ''}</td>
            <td>{partnerStr}</td>
        </tr>
    )
}

UsersStaticsDetailTableItem.propTypes = {
    item: PropTypes.object,
}

export default UsersStaticsDetailTableItem
